/**
 * Ryan O'Dowd
 * 2024-09-21
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import React, {
  useMemo,
  useState,
} from 'react';
import {
  HELP_ROUTE,
} from '@utils/store/actions';
import Text from '@components/common/Text';
import {
  View,
} from 'react-native';
import WidgetBase from '@components/WidgetBase';
import faqs from '@containers/Help/faqs';
import getStyles from './styles';
import hooks from '@hooks';

const Help = (props: HelpProps) => {
  const i18n = hooks.useI18n();
  const navigation = hooks.useNavigation();
  const styles = hooks.useStyles(getStyles);

  /* @TODO:
  if streak is broken:
    render all days that are missing
    render button to restore now (which picks the oldest missing day)
    <Button
      mode='contained'
      theme={styles.colors.accent}
      onPress={() => navigation.navigate(FRIENDS_ROUTE, {
        openTab: 'find',
      })}
    >
      Repair now
    </Button>
  */

  // https://javascript.info/task/shuffle
  const shuffleArray = (array) => {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1)); // random index from 0 to i
      [array[i], array[j]] = [array[j], array[i]];
    }
  };

  const oakUser = hooks.useTypedSelector((state) => state.oakUser);
  const quickTips = useMemo(() => {
    const qt = faqs(styles, navigation, oakUser.isAnonymousUser, oakUser).sections.flatMap((section) => section.data.filter((faq) => faq.isQuickTip));
    shuffleArray(qt);

    return qt;
  }, []); /* eslint-disable-line */ // @TODO: ignore oakUser because this should only ever be built one time

  const [_faqIndex, setFaqIndex] = useState(0);

  return (
    <WidgetBase.Container
      layout={props.layout}
      cellSize={props.cellSize}
    >
      <WidgetBase.Header
        title={i18n('help')}
        onPress={() => navigation.navigate(HELP_ROUTE)}
        rightIconName='refresh'
        onPressRightIcon={() => setFaqIndex((curr) => (curr + 1) % quickTips.length)}
      />
      <WidgetBase.Content>
        <View style={styles.faqWrapper}>
          <Text style={styles.faqQuestion}>{quickTips[_faqIndex].question}</Text>
          {quickTips[_faqIndex].answer}
        </View>
      </WidgetBase.Content>
    </WidgetBase.Container>
  );
};

class HelpProps {
  layout: {
    x: number,
    y: number,
    w: number,
    h: number,
  }; // @TODO: type
  cellSize: number;
};

export default Help;
